export default function() {
  // returns an array of 26 alphabets individually ie. 'a','b','c','d',...
  return "abcdefghijklmnopqrstuvwxyz".split("");
}
